import styled from 'styled-components/native';

import Text from '@components/Text';

export const Container = styled.View``;

export const InvoiceHeader = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  height: 78px;
`;

export const InvoiceHeaderContainer = styled.View``;

export const InvoiceHeaderButton = styled.View``;

export const InvoiceHeaderText = styled(Text)`
  font-size: 12px;
  margin-bottom: 12px;
`;

export const InvoiceHeaderPrice = styled.View`
  flex-direction: row;
`;

export const InvoiceHeaderPriceSymbol = styled(Text)`
  font-size: 12px;
  margin-right: 5px;
`;

export const InvoiceHeaderPriceText = styled(Text)`
  font-size: 30px;
`;

export const InvoiceDescription = styled.View`
  margin-top: 24px;
`;

export const InvoiceDescriptionItem = styled.View`
  flex-direction: row;
  justify-content: space-between;
  padding-top: 20px;

  padding-bottom: ${props => props.border && '20px'};
  border-bottom-color: ${props => props.theme.colors.grayscale.slot2};
  border-bottom-width: ${props => (props.border ? '1px' : 0)};
  border-style: solid;
  border-width: 0;
`;

export const InvoiceDescriptionTitle = styled(Text)`
  font-size: 13px;
`;

export const InvoiceDescriptionValue = styled(Text)`
  font-family: ${props => props.theme.fonts.weight[500]};
`;

export const InvoicePayButtonText = styled.Text`
  font-size: 14px;
  font-family: ${props => props.theme.fonts.weight[500]};
  color: ${props => (props.type === 'pay' ? '#59c00b' : '#0086FF')};
`;

export const InvoicePayButton = styled.TouchableOpacity`
  border: 1.2px solid ${props => (props.type === 'pay' ? '#59c00b' : '#0086FF')};
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 94px;
`;
